import { UploadedFileWithType } from "src/app/services/models/misc.model";

export class SetProjectImageFiles {
    public static readonly type = "[Projects] Save project image files";

    constructor(public payload: UploadedFileWithType[]) {}
}
